import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = (import.meta.env.VITE_API_URL || (import.meta.env.PROD?window.location.origin+'/api/v1':'http://localhost:4000/api/v1')).replace(/\/api\/v1\/?$/, '');

/**
 * Joins the given shop's Socket.IO room and invokes handlers for live events.
 * handlers: { 'queue:update': fn, 'order:new': fn, 'order:status': fn, 'order:paid': fn }
 */
const useShopSocket = (shopId, handlers) => {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!shopId) {
      return undefined;
    }
    const socket = io(SOCKET_URL, { transports: ['websocket', 'polling'] });
    socket.on('connect', () => socket.emit('join-shop', String(shopId)));

    const events = ['queue:update', 'order:new', 'order:status', 'order:paid', 'menu:stock', 'order:invoice', 'bar:license', 'bill:requested', 'cash:updated', 'booking:menu', 'kiosk:background', 'queue:print', 'staff:access'];
    events.forEach((event) => {
      socket.on(event, (payload) => {
        const handler = handlersRef.current?.[event];
        if (handler) {
          handler(payload);
        }
      });
    });

    return () => {
      socket.emit('leave-shop', String(shopId));
      socket.disconnect();
    };
  }, [shopId]);
};

export default useShopSocket;
